import { ArtistsMenu } from "@/components/ui/menu/ArtistsMenu"
import { BottomNavButton } from "@/components/ui/navigation/BottomNavButton"
import { getBookingSystemMainNavItems, type BadgeState } from "@/lib/navigationItems"
import { useUserData } from '@/hooks/useUserData';
import { useUnreadChatsCount } from '@/hooks/useUnreadChatsCount';
import { useBookingSystem } from '@/contexts/BookingSystemContext'
import { isNative } from '@/lib/platform'

export function BookingSystemBottomNav() {
  const { artistId, getCachedProfile } = useUserData();
  const effectiveArtistId = artistId ?? getCachedProfile()?.artistId ?? undefined;
  const { count: unreadCount } = useUnreadChatsCount();
  const { hasBookingSystem, subscription } = useBookingSystem();
  const mainItems = getBookingSystemMainNavItems();

  console.log(`[BottomNav] Booking access: ${hasBookingSystem ? 'granted' : 'denied'} (${subscription?.status ?? 'no-subscription'})`)

  // Build badge state
  const badgeState: BadgeState = {
    unreadCount,
    isNative: isNative(),
  };

  return (
    <div className="bottom-nav-container bottom-nav flex items-center justify-around">
      {mainItems.map((item) => (
        <BottomNavButton
          key={item.id}
          item={item}
          badgeState={badgeState}
          artistId={effectiveArtistId}
          labelOverride={item.id === 'bookingsDashboard' ? 'Bookings' : undefined}
        />
      ))}

      {/* More (Menu) */}
      <ArtistsMenu />
    </div>
  )
}
